
import Vue from 'vue';
  import { Component, Prop, Watch} from 'vue-property-decorator';
import { namespace } from "vuex-class";
const schedule = namespace("schedule");
@Component({
  data:() => {
  return {

  }
  },
})
export default class CalendarFilterPanel extends Vue {
  checkALLOption: boolean = true;
  checkSchedEventsOption: boolean = true;
  checkPendRequestsOption: boolean = true;
  checkDepartNeedsOption: boolean = true;
  checkTradeShiftsOption: boolean = true;
  checkUnavailabilityOption: boolean = true;
  checkALLDefaultOption: boolean = false;

  headerHeight: string = "";
  @Prop({ required: true }) readonly toggleStatus!: boolean;
  public firstClick: boolean = false;

  constructor() {
    super();
  }

  @Watch("toggleStatus", { immediate: true }) onMatchChanged() {
    if (this.toggleStatus) {
      this.headerHeight = "12.5px";
      this.firstClick = true;
    }
  }

  get customTop() {
    if (this.firstClick) {
      return `top:${this.headerHeight}`;
    } else {
      return "";
    }
  }

  onCheckAll() {
    this.checkSchedEventsOption = this.checkALLOption;
    this.checkPendRequestsOption = this.checkALLOption;
    this.checkDepartNeedsOption = this.checkALLOption;
    this.checkTradeShiftsOption = this.checkALLOption;
  }

  onCheckSchedEvents() {
    try {
      this.validateEventTypes("scheduledEvents");
      this.$emit("sched-event", this.checkSchedEventsOption);
    } catch (e) {
      console.log(e);
    }
  }

  onCheckPendRequestsOption() {
    try {
      this.validateEventTypes("pendingEvents");
      this.$emit("check-pend-event", this.checkPendRequestsOption);
    } catch (e) {
      console.log(e);
    }
  }

  onCheckDepartNeedsOption() {
    try {
      this.validateEventTypes("openneedEvents");
      this.$emit("check-depart-need-event", this.checkDepartNeedsOption);
    } catch (e) {
      console.log(e);
    }
  }

  onCheckTradeShiftsOption() {
    try {
      this.validateEventTypes("tradeEvents");
      this.$emit("check-trade-shift-event", this.checkTradeShiftsOption);
    } catch (e) {
      console.log(e);
    }
  }

  onCheckUnavailabilityOption() {
    try {
      this.validateEventTypes("unavailEvents");
      this.$emit("check-unavailability-event", this.checkUnavailabilityOption);
    } catch (e) {
      console.log(e);
    }
  }

  onCheckAllOption() {
    try {
      this.checkSchedEventsOption = this.checkALLOption;
      this.checkPendRequestsOption = this.checkALLOption;
      this.checkDepartNeedsOption = this.checkALLOption;
      this.checkTradeShiftsOption = this.checkALLOption;
      this.checkUnavailabilityOption = this.checkALLOption;
      this.$emit("check-all", this.checkALLOption);
    } catch (e) {
      console.log(e);
    }
  }

  closeNav() {
    try {
      this.$emit("close-event");
    } catch (e) {
      console.log(e);
    }
  }

  validateEventTypes(flag) {
            let schedEvents = this.checkSchedEventsOption;
            let pendEvents = this.checkPendRequestsOption;
            let openneedEvents = this.checkDepartNeedsOption;
            let tradeshiftEvents = this.checkTradeShiftsOption;
            let unavailEvents = this.checkUnavailabilityOption;

            if (flag == 'scheduledEvents') {
                if (unavailEvents == true && pendEvents == true && openneedEvents == true && tradeshiftEvents == true) {
                    this.checkALLOption = schedEvents;
                }
            }
            else if (flag == 'pendingEvents') {
                if (schedEvents == true && openneedEvents == true && tradeshiftEvents == true && unavailEvents == true) {
                    this.checkALLOption = pendEvents;
                }
            }
            else if (flag == 'openneedEvents') {
                if (schedEvents == true && tradeshiftEvents == true && pendEvents == true && unavailEvents == true) {
                    this.checkALLOption = openneedEvents;
                }
            }
            else if (flag == 'tradeEvents') {
                if (schedEvents == true && pendEvents == true && unavailEvents == true && openneedEvents == true) {
                    this.checkALLOption = tradeshiftEvents;
                }
            }
            else if (flag == 'unavailEvents') {
                if (schedEvents == true && pendEvents == true && tradeshiftEvents == true && openneedEvents == true) {
                    this.checkALLOption = unavailEvents;
                }
            }
        }

}
